"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ChatContextSchema = exports.ChatContextSource = exports.ChatMessageType = exports.ChatMessageSchema = exports.ChatResponseSchema = exports.ActionType = exports.ChatRole = exports.ChatAction = void 0;
const zod_1 = require("zod");
const __1 = require("..");
const base_1 = require("../base");
var ChatAction;
(function (ChatAction) {
    ChatAction[ChatAction["Default"] = 0] = "Default";
    ChatAction[ChatAction["SuggestStorefrontShareMessage"] = 1] = "SuggestStorefrontShareMessage";
    ChatAction[ChatAction["HelpStoreToGetTheFirst60Visitors"] = 2] = "HelpStoreToGetTheFirst60Visitors";
    ChatAction[ChatAction["HelpStoreShareCatalog"] = 3] = "HelpStoreShareCatalog";
    ChatAction[ChatAction["OrderShippingDetailsRequested"] = 5] = "OrderShippingDetailsRequested";
    ChatAction[ChatAction["OrderUpdateStatusRequested"] = 6] = "OrderUpdateStatusRequested";
    ChatAction[ChatAction["OrderUpdateStatusToCanceled"] = 8] = "OrderUpdateStatusToCanceled";
    ChatAction[ChatAction["OrderUpdateStatusToPaid"] = 9] = "OrderUpdateStatusToPaid";
    ChatAction[ChatAction["OrderUpdateStatusToPendingPayment"] = 10] = "OrderUpdateStatusToPendingPayment";
    ChatAction[ChatAction["OrderUpdateStatusToShipped"] = 11] = "OrderUpdateStatusToShipped";
    ChatAction[ChatAction["CreateItemFlow"] = 4] = "CreateItemFlow";
    ChatAction[ChatAction["DontCreateItem"] = 12] = "DontCreateItem";
})(ChatAction || (exports.ChatAction = ChatAction = {}));
var ChatRole;
(function (ChatRole) {
    ChatRole["User"] = "user";
    ChatRole["System"] = "system";
    ChatRole["Assistant"] = "assistant";
})(ChatRole || (exports.ChatRole = ChatRole = {}));
var ActionType;
(function (ActionType) {
    ActionType["Send"] = "SEND";
    ActionType["Fetch"] = "FETCH";
})(ActionType || (exports.ActionType = ActionType = {}));
exports.ChatResponseSchema = zod_1.z.object({
    action: zod_1.z.nativeEnum(ActionType),
    data: zod_1.z.object({
        contentType: zod_1.z.enum(['text', 'link']),
        content: zod_1.z.object({
            text: zod_1.z.string(),
            link: zod_1.z
                .object({
                url: zod_1.z.string(),
                label: zod_1.z.string(),
            })
                .array()
                .optional(),
        }),
    }),
});
exports.ChatMessageSchema = zod_1.z.object({
    role: zod_1.z.nativeEnum(ChatRole),
    content: zod_1.z.string(),
    json: exports.ChatResponseSchema.optional(),
});
var ChatMessageType;
(function (ChatMessageType) {
    /**
     * Chat messages between user and assistant.
     */
    ChatMessageType["Chat"] = "chat";
    /**
     * Transactional notifications (i.e. new order, subscription renewal, etc).
     */
    ChatMessageType["Notification"] = "notification";
    /**
     * Reports and insights.
     */
    ChatMessageType["Report"] = "report";
    /**
     * Messages that are sent to the user to trigger a specific action.
     */
    ChatMessageType["ActiveWindow"] = "active_window";
})(ChatMessageType || (exports.ChatMessageType = ChatMessageType = {}));
var ChatContextSource;
(function (ChatContextSource) {
    ChatContextSource["WhatsApp"] = "WHATSAPP";
    ChatContextSource["RediRediApp"] = "REDIREDI_APP";
    ChatContextSource["RediRediWebAppDesktop"] = "RR_WEB_APP_DESKTOP";
    ChatContextSource["RediRediWebAppMobile"] = "RR_WEB_APP_MOBILE";
    ChatContextSource["RediRediIOsApp"] = "RR_IOS_APP";
    ChatContextSource["RediRediAndroidApp"] = "RR_ANDROID_APP";
})(ChatContextSource || (exports.ChatContextSource = ChatContextSource = {}));
exports.ChatContextSchema = base_1.BaseSchema.extend({
    store: __1.StoreWithUserPhoneNumberSchema,
    image: zod_1.z
        .object({
        url: zod_1.z.string().url(),
        mimeType: zod_1.z.string(),
    })
        .optional(),
    whatsappId: zod_1.z.string().optional(),
    replyOf: zod_1.z.string().optional(),
    text: zod_1.z.string().optional(),
    role: zod_1.z.nativeEnum(ChatRole).optional(),
    modelId: zod_1.z.string().optional(),
    sendAt: zod_1.z.coerce.date(),
    actionId: zod_1.z.nativeEnum(ChatAction).optional(),
    actionStep: zod_1.z.number().optional(),
    type: zod_1.z.nativeEnum(ChatMessageType).optional(),
    // TODO: improve naming. this is related to the formatted links response from the LLM models
    chatResponse: exports.ChatResponseSchema.optional(),
    source: zod_1.z.nativeEnum(ChatContextSource).optional(),
});
//# sourceMappingURL=chat-context.js.map